module.exports = __webpack_public_path__ + "img/lightbulb.98eab522.svg";